import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation";
import tr from "./locales/tr/translation";
import ar from "./locales/ar/translation";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      ar: { translation: ar },
    },

    supportedLngs: ["en", "tr", "ar"],
    nonExplicitSupportedLngs: true, // tr-TR gibi değerleri destekli say
    load: "languageOnly", // tr-TR -> tr
    fallbackLng: "tr", // TR default istiyorsan

    detection: {
      order: ["localStorage", "cookie", "htmlTag", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "lng",
    },

    interpolation: { escapeValue: false },
    debug: true,
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
